import styled from 'styled-components'

import { Badge } from '@/components/ui/badge'
import { Tooltip } from '@/components/ui/tooltip'

export const Cell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  minWidth: 0,
}))

// Note: ui/tooltip's container doesn't shrink by itself - without this the text lines below
// overflow the cell instead of truncating with an ellipsis. It only takes the text's own width
// (no growing), so an extra after it (a "+N" or "Marketplace" badge) sits right next to the text.
export const TextTooltip = styled(Tooltip)({
  flex: '0 1 auto',
  minWidth: 0,
})

export const Text = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
})

export const FirstLine = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['4'],
  minWidth: 0,
}))

// Note: the name gives way (ellipsis) before the tags do
export const Name = styled.span({
  flexShrink: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const Tag = styled(Badge)(({ theme }) => ({
  alignItems: 'center',
  display: 'inline-flex',
  flexShrink: 0,
  gap: theme.space['2'],
  whiteSpace: 'nowrap',
}))

export const Details = styled.span(({ theme }) => ({
  color: theme.colors.black400,
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const TooltipLines = styled.span({
  display: 'flex',
  flexDirection: 'column',
})

// Note: an email / phone on the second line - looks like the text around it, copies on click
export const CopyValue = styled.button(({ theme }) => ({
  '&:focus-visible': {
    outline: `${theme.border.size['2']} solid ${theme.colors.blue500}`,
  },
  '&:hover': {
    color: theme.colors.black600,
    textDecoration: 'underline',
  },
  background: 'none',
  border: 'none',
  color: 'inherit',
  cursor: 'copy',
  font: 'inherit',
  padding: 0,
}))
